import { useMutation, useQueryClient } from '@tanstack/react-query';
import { companyApis } from '../../../../../../../shared/apis/company/apis';
import { queries } from '../../../../../../../shared/queries';

export default function usePostUploadCompleted() {
  const queryClient = useQueryClient();
  return useMutation(companyApis.postCompleteUpload, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queries.aiAgent.equipmentModelList._def });
    },
  });
}
